import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css';

export default class Card extends React.Component {
  
  render() {
    let title = null;
    let subtitle = null;
    let footer = null;

    if ( typeof this.props.title === 'string' ) {
      title = <div className={style.cardTitle}>{this.props.title}</div>
    } else {
      title = this.props.title
    }

    if ( typeof this.props.subtitle === 'string' ) {
      subtitle = <div className={style.cardSubtitle}>{this.props.title}</div>
    } else {
      subtitle = this.props.subtitle
    }

    if ( typeof this.props.footer === 'string' ) {
      footer = <div className={style.footer}>{this.props.footer}</div>
    } else {
      footer = this.props.footer
    }
    
    const clazz = classNames( style.card, this.props.className );
    return (
      <div className={clazz}>
        {title}
        {subtitle}
        {this.props.children}
        {footer}
      </div>
    )
  }
}
